import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const styles = css`
  display: flex;
  align-items: center;
  gap: ${spacing(1)};
  overflow: hidden;
  cursor: pointer;

  .icon-wrapper {
    display: flex;
    align-items: center;
    position: relative;
  }
`
